import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/core";
import * as React from "react";

const emotionInstance = createCache({ container: document.getElementsByTagName("body")[0] });

export const EmotionCache: React.FC = ({ children }) => (
  <CacheProvider value={emotionInstance}>{children}</CacheProvider>
);
